import { useMutation } from '@tanstack/react-query';

import {
  payCalendarsService,
  CreateExternalPayCalendarRequest,
  CreateExternalPayCalendarsResponse,
} from '@aslanpay/portal-common-lib';

/**
 * Bulk-creates pay calendars (source=EXTERNAL) whose initial pay cycles are seeded from real, already-known
 * pay-period dates, applying every valid row rather than rolling the whole batch back on one bad row - used
 * to create the newly-confirmed Cezanne companies' pay calendars from the sync's pay schedules.
 */
const useCreateExternalPayCalendars = () => {
  return useMutation<CreateExternalPayCalendarsResponse, Error, CreateExternalPayCalendarRequest[]>(
    (requests) => payCalendarsService.createExternalPayCalendars(requests)
  );
};

export default useCreateExternalPayCalendars;
